module.exports = __webpack_public_path__ + "media/images/kf_1-3f794a976c28a479e73a90b0d8dbe639.png";